import type { ComponentChildren } from 'preact';
import { TopBar } from './TopBar';

interface PageLayoutProps {
  activePage: string;
  children: ComponentChildren;
}

export function PageLayout({ activePage, children }: PageLayoutProps) {
  return (
    <>
      <TopBar activePage={activePage} />
      {children}
    </>
  );
}
